export const limit = (string, length, end = "...") => {
  if (string)
    return string.length < length ? string : string.substring(0, length) + end;
  return string;
};
